module.exports = __webpack_public_path__ + "static/media/ar1.c1d1b440.jpg";